import { render, staticRenderFns } from "./SearcherMaterialCategory.vue?vue&type=template&id=1175102a&scoped=true&"
import script from "./SearcherMaterialCategory.vue?vue&type=script&lang=js&"
export * from "./SearcherMaterialCategory.vue?vue&type=script&lang=js&"
import style0 from "./SearcherMaterialCategory.vue?vue&type=style&index=0&id=1175102a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1175102a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VAutocomplete,VIcon,VMenu,VSheet,VTreeview})
